<template>
  <div class="loaderui loaderui-sm" v-bind:class="{ 'loaderui-loaded': loaded }">
    <div>
      <ul class="nav nav-tabs m-bottom-0" role="tablist">
        <li role="presentation" class="active"><a href="#messages" aria-controls="messages" role="tab" data-toggle="tab">Alle berichten</a></li>
        <li role="presentation"><a href="#files" aria-controls="files" role="tab" data-toggle="tab">Alleen bestanden</a></li>
        <li role="presentation"><a href="#media" aria-controls="media" role="tab" data-toggle="tab">Mediabibliotheek</a></li>
      </ul>

      <div class="tab-content p-15 comments-tab-content">
        <div role="tabpanel" class="tab-pane active" id="messages">
          <template v-if="comments.length > 0">
            <job-comment
                v-for="comment in comments"
                :user-id="user.id"
                :user-role="user.role"
                :comment="comment"
                :change-comment="changeComment"
                :key="`comment-${comment.id}`"
                @delete="deleteComment"
            ></job-comment>
          </template>

          <span v-else-if="error" class="alert alert-danger">Er is een fout opgetreden</span>

          <span v-else>Er zijn geen berichten voor deze opdracht.</span>
        </div>

        <div role="tabpanel" class="tab-pane" id="files">
          <template v-if="mediaComments.length > 0">
            <job-comment
                v-for="comment in mediaComments"
                :user-id="user.id"
                :user-role="user.role"
                :comment="comment"
                :change-comment="changeComment"
                :key="`comment-${comment.id}`"
                @delete="deleteComment"
            ></job-comment>
          </template>

          <span v-else>Er zijn geen berichten met bestanden voor deze opdracht.</span>
        </div>

        <div role="tabpanel" class="tab-pane" id="media">
          <div class="media-grid" v-if="hasMedia">
            <div
                v-for="media in files"
                class="media-grid-group"
            >
              <div class="media-grid-title">
                <h5>{{ media.comment }}</h5>
              </div>

              <div>
                <div>
                  <ul class="list-unstyled list-media" v-if="media.files.length > 0">
                    <li v-for="file in media.files">
                      <a v-if="file" :href="file.full_url" target="_blank" :style="{ 'background-image': `url(${file.full_url})` }"></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div v-else>
            Er zijn geen afbeeldingen gekoppeld aan deze opdracht.
          </div>
        </div>
      </div>
    </div>

    <job-comment-form
      v-if="loaded"
      :job-id="jobId"
      :job-deleted="jobDeleted"
      :user="user"
      @submitted="commentSubmitted"
    ></job-comment-form>
  </div>
</template>

<script>
  import JobComment from './Comment.vue';
  import JobCommentForm from './Form.vue';

  export default {
    name: 'JobCommentList',

    components: {
      JobComment,
      JobCommentForm
    },

    props: {
      user: {
        type: Object,
        required: true,
      },

      jobId: {
        type: Number,
        required: true,
      },

      jobDeleted: {
        type: Boolean,
        required: true,
      },

      changeComment: {
        type: Boolean,
        default: true,
      },
    },

    data() {
      return {
        loaded: false,
        error: false,
        comments: [],
        files: [],
      }
    },

    created: function() {
      this.$http.get(`/ritten/${this.jobId}/comments`)
          .then(function(response) {
            this.comments = response.data.comments;
            this.files = response.data.files;

            this.loaded = true;

            this.$emit('loaded');

            setTimeout(() => {
              const element = document.getElementsByClassName('comments-tab-content')[0];
              element.scrollTop = element.scrollHeight;
            }, 100);

          }, function (response) {
            this.error = true;
          });
    },

    computed: {
      mediaComments() {
        return this.comments.filter(comment => comment.media.length > 0);
      },

      hasMedia() {
        if (this.files.length) {
          return this.files.some(file => {
            return file.files.length > 0;
          });
        }

        return false;
      },
    },

    methods: {
      deleteComment(commentId) {
        this.comments = this.comments.filter(comment => comment.id !== commentId);

        this.$emit('change', this.comments.length);
      },

      commentSubmitted(comment) {
        this.comments.push(comment);

        this.$emit('change', this.comments.length);
      },
    }
  }
</script>



// WEBPACK FOOTER //
// resources/js/components/Job/Comments/Index.vue